import React, { useEffect } from "react";
import PropTypes from 'prop-types'
import { withRouter } from "react-router-dom"
import Header from "../../src/pages/JSBForms/Header"
import BranchHeader from "../../src/pages/JSBForms/BranchHeader"
import Footer from "../../src/pages/JSBForms/Footer"

const NonAuthLayout = (props) => {
    var pageUrl = props.match.url;

    oncontextmenu = function () { return false; };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <React.Fragment>

            {pageUrl.toLowerCase()  == "/customerlist" ? <BranchHeader /> : (pageUrl.toLowerCase()  == "/login" || pageUrl.toLowerCase() == "/success" || pageUrl.toLowerCase()  == "/branchlogin") ? <></> : <Header />}
            {props.children}
            {pageUrl.toLowerCase()  == "/login" || pageUrl.toLowerCase()  == "/success" || pageUrl.toLowerCase() == "/branchlogin" ? <></> : <Footer />}
        </React.Fragment>
    );
}

NonAuthLayout.propTypes = {
    children: PropTypes.any,
    location: PropTypes.object,
    match: PropTypes.string,
    url: PropTypes.string
}

export default withRouter(NonAuthLayout)
